export default __webpack_public_path__ + "images/BI.168c664.png";